import { NgModule } from '@angular/core';
import * as ngRecaptcha from 'ng-recaptcha';

import { environment } from '@environments/environment';
import { TranslateService } from '../translate/services/translate.service';

@NgModule({
  imports: [ngRecaptcha.RecaptchaModule],
  exports: [ngRecaptcha.RecaptchaModule],
  providers: [
    {
      provide: ngRecaptcha.RECAPTCHA_SETTINGS,
      useValue: {
        siteKey: environment.RECAPTCHA_SITE_KEY,
        size: 'invisible'
      } as ngRecaptcha.RecaptchaSettings
    },
    {
      provide: ngRecaptcha.RECAPTCHA_LANGUAGE,
      deps: [TranslateService],
      useFactory: (translateService: TranslateService) => {
        return translateService.getLocale(true).toLowerCase();
      }
    }
  ]
})
export class RecaptchaModule {}
